let initTimeout;
const initCallbacks = [];

function registerInitCallback(callback) {
    initCallbacks.push(callback);
}

function runAllCallbacks() {
    initCallbacks.forEach(callback => callback());
}

// Check if DOM is already loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAllCallbacks);
} else {
    setTimeout(runAllCallbacks, 0);
}

// Single observer for all dynamic content
const observer = new MutationObserver(() => {
    clearTimeout(initTimeout);
    initTimeout = setTimeout(runAllCallbacks, 200);
});

observer.observe(document.body, { childList: true, subtree: true });